<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn th-btn-normal"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ 'common.edit' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
<span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.spo-locking.name' | translate }}</span
      >
    </div>
  </div>
    <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content">
        <td class="th-plugin-line--data" *ngFor="let message of messages">
          <span>{{ message }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <table class="ir-plugin-table" *ngIf="spoLockings?.length > 0">
      <tr class="th-plugin-line--header">
        <td colspan="4">
          <span>{{ 'plugins.spo-locking.os' | translate }}</span>
        </td>
        <td colspan="4">
          <span>{{ 'plugins.spo-locking.oos' | translate }}</span>
        </td>
      </tr>
      <tr class="th-plugin-line--subheader">
        <td>
          <span>N°</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.spo-locking.theoretical' | translate }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.spo-locking.measured' | translate }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.spo-locking.difference' | translate }}</span>
        </td>
        <td>
          <span></span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.spo-locking.theoretical' | translate }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.spo-locking.measured' | translate }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ 'plugins.spo-locking.difference' | translate }}</span>
        </td>
      </tr>
      <tr class="th-plugin-line--content" *ngFor="let item of spoLockings">
        <td>
          <span>{{ item.Id }}.</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ item.OsLocked }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ item.OsUnlock }}</span>
        </td>
        <td class="th-plugin-line--value important">
          <span>{{ item.OsLocked - item.OsUnlock | number: '1.2-2' }}</span>
        </td>
        <td>
          <span></span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ item.OssLocked }}</span>
        </td>
        <td class="th-plugin-line--value">
          <span>{{ item.Ossunlock }}</span>
        </td>
        <td class="th-plugin-line--value important">
          <span>{{ item.OssLocked - item.Ossunlock | number: '1.2-2' }}</span>
        </td>
      </tr>
    </table>
  </div>
</div>
